/**
 * ╔══════════════════════════════════════════════════════════════════════╗
 * ║           COCONUT TREE BRASIL — SCRUNCHIE SURPRESA BRINDE           ║
 * ║                                                                      ║
 * ║  Adiciona/remove o Scrunchie Surpresa automaticamente quando o       ║
 * ║  subtotal do carrinho ultrapassa/cai abaixo de R$199,90.             ║
 * ║                                                                      ║
 * ║  Inclui barra de progresso visual no CornerCart.                     ║
 * ║  Compatível com: CornerCart (não usa cart drawer nativo do tema)     ║
 * ╚══════════════════════════════════════════════════════════════════════╝
 *
 * INSTALAÇÃO:
 *   Shopify Admin → Online Store → Themes → Edit code
 *   Salve este arquivo em Assets → scrunchie-gift.js
 *   No theme.liquid, antes de </body>, adicione:
 *   <script src="{{ 'scrunchie-gift.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  // ─── CONFIGURAÇÃO ────────────────────────────────────────────────────────────

  const CONFIG = {
    // ID da variante do Scrunchie Surpresa
    variantId: 54179318366576,

    // Valor mínimo em centavos (R$199,90 = 19990)
    thresholdCents: 19990,

    // Propriedades de linha que identificam o brinde (prefixo _ = oculto no checkout)
    lineProperties: {
      _is_gift:    'true',
      _gift_label: 'Brinde',
    },

    // Mensagens — toasts
    messages: {
      added:   '🎉 Scrunchie Surpresa adicionado ao carrinho como brinde!',
      removed: '🛍️ Scrunchie Surpresa removido (compra abaixo de R$199,90).',
      manual:  '🎁 Adicione mais R$${remaining} e leve o Scrunchie Surpresa de graça!',
    },

    // Textos da barra de progresso
    progress: {
      heading:   '🎁 Ganhe um Scrunchie Surpresa!',
      remaining: 'Faltam <strong>R$${remaining}</strong> para ganhar seu brinde',
      reached:   '🎉 Você ganhou um <strong>Scrunchie Surpresa</strong> de brinde!',
    },

    // Cor de destaque da barra (personalize conforme o tema da loja)
    progressColor: '#c8a97e',

    // Debounce em ms
    debounceMs: 400,
  };

  // ─── ESTADO INTERNO ──────────────────────────────────────────────────────────

  let _isProcessing  = false;
  let _debounceTimer = null;

  // ─── UTILIDADES ──────────────────────────────────────────────────────────────

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Falha ao buscar carrinho');
    return res.json();
  }

  async function addToCart(variantId, properties = {}) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Erro ao adicionar item');
    }
    return res.json();
  }

  async function removeFromCart(lineKeys) {
    const updates = {};
    lineKeys.forEach(k => { updates[k] = 0; });
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
    if (!res.ok) throw new Error('Erro ao remover item');
    return res.json();
  }

  function formatBRL(cents) {
    return (cents / 100).toFixed(2).replace('.', ',');
  }

  // ─── TOAST ───────────────────────────────────────────────────────────────────

  function showToast(message, type = 'success') {
    if (window.cornerCart && typeof window.cornerCart.showNotification === 'function') {
      window.cornerCart.showNotification({ message, type });
      return;
    }

    const existing = document.getElementById('cct-gift-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.id = 'cct-gift-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = message;

    const colors = {
      success: { bg: '#2d6a4f', border: '#1b4332' },
      info:    { bg: '#1d4e89', border: '#0f2e56' },
      warning: { bg: '#b5451b', border: '#7a2e0e' },
    };
    const c = colors[type] || colors.success;

    Object.assign(toast.style, {
      position:      'fixed',
      bottom:        '24px',
      left:          '50%',
      transform:     'translateX(-50%) translateY(20px)',
      background:    c.bg,
      border:        `1px solid ${c.border}`,
      color:         '#ffffff',
      padding:       '12px 20px',
      borderRadius:  '8px',
      fontSize:      '14px',
      fontFamily:    'inherit',
      maxWidth:      '90vw',
      boxShadow:     '0 4px 16px rgba(0,0,0,.25)',
      zIndex:        '999999',
      opacity:       '0',
      transition:    'opacity .25s ease, transform .25s ease',
      pointerEvents: 'none',
    });

    document.body.appendChild(toast);
    requestAnimationFrame(() => {
      toast.style.opacity   = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    });
    setTimeout(() => {
      toast.style.opacity   = '0';
      toast.style.transform = 'translateX(-50%) translateY(10px)';
      toast.addEventListener('transitionend', () => toast.remove(), { once: true });
    }, 4000);
  }

  // ─── BARRA DE PROGRESSO ──────────────────────────────────────────────────────

  /**
   * Injeta os estilos da barra uma única vez no <head>.
   */
  function injectProgressStyles() {
    if (document.getElementById('cct-progress-styles')) return;

    const style = document.createElement('style');
    style.id = 'cct-progress-styles';
    style.textContent = `
      #cct-progress-bar-wrapper {
        padding: 14px 16px 10px;
        font-family: inherit;
        border-bottom: 1px solid rgba(0,0,0,.08);
        background: transparent;
      }

      #cct-progress-heading {
        font-size: 13px;
        font-weight: 600;
        margin: 0 0 8px;
        color: inherit;
      }

      #cct-progress-track {
        width: 100%;
        height: 8px;
        background: rgba(0,0,0,.10);
        border-radius: 999px;
        overflow: hidden;
        margin-bottom: 6px;
      }

      #cct-progress-fill {
        height: 100%;
        border-radius: 999px;
        background: ${CONFIG.progressColor};
        transition: width .45s cubic-bezier(.4,0,.2,1);
        width: 0%;
      }

      #cct-progress-fill.cct-complete {
        background: #2d6a4f;
      }

      #cct-progress-label {
        font-size: 12px;
        color: inherit;
        opacity: .75;
        margin: 0;
      }

      #cct-progress-label strong {
        opacity: 1;
        color: inherit;
        font-weight: 700;
      }

      #cct-progress-label.cct-complete {
        opacity: 1;
        font-weight: 600;
        color: #2d6a4f;
      }

      /* Animação de "pulso" ao completar */
      @keyframes cct-pop {
        0%   { transform: scaleX(1); }
        50%  { transform: scaleX(1.015); }
        100% { transform: scaleX(1); }
      }

      #cct-progress-fill.cct-complete {
        animation: cct-pop .35s ease;
      }
    `;
    document.head.appendChild(style);
  }

  /**
   * Cria o elemento da barra de progresso se ainda não existir.
   * @returns {HTMLElement}
   */
  function getOrCreateProgressBar() {
    let wrapper = document.getElementById('cct-progress-bar-wrapper');
    if (wrapper) return wrapper;

    wrapper = document.createElement('div');
    wrapper.id = 'cct-progress-bar-wrapper';
    wrapper.innerHTML = `
      <p id="cct-progress-heading">${CONFIG.progress.heading}</p>
      <div id="cct-progress-track">
        <div id="cct-progress-fill"></div>
      </div>
      <p id="cct-progress-label"></p>
    `;
    return wrapper;
  }

  /**
   * Tenta inserir a barra dentro do drawer do CornerCart.
   * O CornerCart usa um shadow DOM ou um elemento com atributo data-corner-cart.
   * Tentamos os seletores mais comuns — ajuste se necessário.
   *
   * @returns {boolean} true se conseguiu inserir
   */
  function mountProgressBar(wrapper) {
    // Seletores conhecidos do CornerCart (em ordem de preferência)
    const candidates = [
      '[data-corner-cart] [data-cart-header]',
      '[data-corner-cart] .corner-cart__header',
      '[data-corner-cart] .cart-header',
      'corner-cart [data-cart-header]',
      '#corner-cart [data-cart-header]',
      '[data-corner-cart] .cart__inner',
      '[data-corner-cart]',
      '#corner-cart',
      'corner-cart',
    ];

    for (const selector of candidates) {
      const target = document.querySelector(selector);
      if (target) {
        // Insere logo após o header (ou no início do container)
        const header = target.querySelector('[data-cart-header], .corner-cart__header, .cart-header');
        if (header && header.parentNode) {
          header.parentNode.insertBefore(wrapper, header.nextSibling);
        } else {
          target.prepend(wrapper);
        }
        return true;
      }
    }

    return false;
  }

  /**
   * Atualiza visualmente a barra de progresso com base no subtotal atual.
   * Cria/move o elemento conforme necessário.
   *
   * @param {number} eligibleSubtotalCents  subtotal sem contar o brinde automático
   */
  function updateProgressBar(eligibleSubtotalCents) {
    injectProgressStyles();

    const pct       = Math.min(100, (eligibleSubtotalCents / CONFIG.thresholdCents) * 100);
    const reached   = eligibleSubtotalCents >= CONFIG.thresholdCents;
    const remaining = formatBRL(Math.max(0, CONFIG.thresholdCents - eligibleSubtotalCents));

    const wrapper = getOrCreateProgressBar();
    const fill    = wrapper.querySelector('#cct-progress-fill');
    const label   = wrapper.querySelector('#cct-progress-label');

    // Atualiza valores
    fill.style.width = `${pct}%`;
    fill.classList.toggle('cct-complete', reached);
    label.classList.toggle('cct-complete', reached);
    label.innerHTML = reached
      ? CONFIG.progress.reached
      : CONFIG.progress.remaining.replace('${remaining}', remaining);

    // Monta no drawer do CornerCart se ainda não estiver no DOM
    if (!document.getElementById('cct-progress-bar-wrapper')) {
      const mounted = mountProgressBar(wrapper);

      // Se o drawer ainda não estava aberto/renderizado, tenta de novo quando abrir
      if (!mounted) {
        waitForCornerCart(wrapper);
      }
    }
  }

  /**
   * Observa o DOM até o CornerCart aparecer e então insere a barra.
   * Útil na primeira vez que o drawer é aberto.
   */
  function waitForCornerCart(wrapper) {
    const selectors = [
      '[data-corner-cart]',
      '#corner-cart',
      'corner-cart',
    ];

    const observer = new MutationObserver(() => {
      for (const sel of selectors) {
        if (document.querySelector(sel)) {
          observer.disconnect();
          // Aguarda um frame para o CornerCart terminar de renderizar
          requestAnimationFrame(() => mountProgressBar(wrapper));
          return;
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Timeout de segurança — não observa indefinidamente
    setTimeout(() => observer.disconnect(), 30000);
  }

  // ─── LÓGICA PRINCIPAL ────────────────────────────────────────────────────────

  async function syncGift() {
    if (_isProcessing) return;
    _isProcessing = true;

    try {
      const cart = await fetchCart();

      const subtotalCents = cart.total_price;

      const giftLines       = cart.items.filter(i => i.variant_id === CONFIG.variantId);
      const autoGiftLines   = giftLines.filter(i => i.properties && i.properties._is_gift === 'true');
      const manualGiftLines = giftLines.filter(i => !i.properties || i.properties._is_gift !== 'true');

      const giftLinePriceCents = autoGiftLines.reduce((acc, i) => acc + i.final_line_price, 0);
      const eligibleSubtotal   = subtotalCents - giftLinePriceCents;

      const qualifies   = eligibleSubtotal >= CONFIG.thresholdCents;
      const hasAutoGift = autoGiftLines.length > 0;

      // ── Atualiza barra de progresso ──────────────────────────────────────
      updateProgressBar(eligibleSubtotal);

      // ── Adicionar brinde ─────────────────────────────────────────────────
      if (qualifies && !hasAutoGift) {
        await addToCart(CONFIG.variantId, CONFIG.lineProperties);
        refreshCornerCart();
        showToast(CONFIG.messages.added, 'success');

      // ── Remover brinde ───────────────────────────────────────────────────
      } else if (!qualifies && hasAutoGift) {
        const keysToRemove = autoGiftLines.map(i => i.key);
        await removeFromCart(keysToRemove);
        refreshCornerCart();
        showToast(CONFIG.messages.removed, 'info');
      }

      // ── Aviso para adição manual sem qualificar ──────────────────────────
      if (!qualifies && manualGiftLines.length > 0) {
        const remainingCents = CONFIG.thresholdCents - eligibleSubtotal;
        const remaining      = formatBRL(remainingCents);
        const msg            = CONFIG.messages.manual.replace('${remaining}', remaining);
        showToast(msg, 'warning');
      }

    } catch (err) {
      console.warn('[Coconut Tree] Erro ao sincronizar brinde:', err);
    } finally {
      _isProcessing = false;
    }
  }

  // ─── REFRESH DO CORNERCART ───────────────────────────────────────────────────

  function refreshCornerCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    window.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('theme:cart:update'));

    if (window.cornerCart) {
      if (typeof window.cornerCart.refresh    === 'function') window.cornerCart.refresh();
      if (typeof window.cornerCart.reload     === 'function') window.cornerCart.reload();
      if (typeof window.cornerCart.updateCart === 'function') window.cornerCart.updateCart();
    }
  }

  // ─── DEBOUNCE ────────────────────────────────────────────────────────────────

  function debouncedSync() {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(syncGift, CONFIG.debounceMs);
  }

  // ─── INTERCEPTAÇÃO DE REQUISIÇÕES ────────────────────────────────────────────

  function isCartMutationUrl(url) {
    return /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/.test(url);
  }

  function interceptCartRequests() {
    // fetch
    const _fetch = window.fetch;
    window.fetch = async function (...args) {
      const result = await _fetch.apply(this, args);
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url ?? '';
      if (isCartMutationUrl(url)) {
        result.clone().json().then(() => debouncedSync()).catch(() => {});
      }
      return result;
    };

    // XMLHttpRequest
    const _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this._url = url;
      return _open.call(this, method, url, ...rest);
    };

    const _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (...args) {
      this.addEventListener('load', () => {
        if (isCartMutationUrl(this._url || '')) debouncedSync();
      });
      return _send.apply(this, args);
    };
  }

  // ─── INICIALIZAÇÃO ───────────────────────────────────────────────────────────

  function init() {
    interceptCartRequests();
    syncGift();

    ['cart:updated', 'cart:refresh', 'theme:cart:update'].forEach(evt => {
      document.addEventListener(evt, debouncedSync);
      window.addEventListener(evt, debouncedSync);
    });

    console.log('[Coconut Tree] 🥥 Scrunchie Surpresa: monitoramento ativo (limite R$199,90)');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();